(() => {
  const mediaQuery = window.matchMedia('(min-width: 60rem)');
  const isDesktop = () => mediaQuery.matches;

  document.querySelectorAll('.header-quick-access').forEach((bar) => {
    const fixedScrollDesktop = !!parseInt(bar.dataset.fixedScrollDesktop, 10);
    const fixedScrollMobile = !!parseInt(bar.dataset.fixedScrollMobile, 10);
    const hideOnScrollDownDesktop = !!parseInt(bar.dataset.hideScrollDownDesktop, 10);
    const hideOnScrollDownMobile = !!parseInt(bar.dataset.hideScrollDownMobile, 10);

    let startHeight = 0;
    let height = 0;
    let lastScrollY = window.scrollY;
    let scrollingUpActive = false;
    let scrollingDownActive = false;

    const calculateStartHeight = () => {
      startHeight = 0;

      let node = bar.parentNode.previousElementSibling;
      while (node) {
        startHeight += node.offsetHeight || 0;
        node = node.previousElementSibling;
      }

      if(document.querySelector('#wpadminbar')){
        startHeight += document.querySelector('#wpadminbar').offsetHeight;
      }

      bar.style.setProperty('--start-height', startHeight + 'px');
    }

    const addFixedOffsetsRecursively = (element) => {
      let offset = 0;
      const style = window.getComputedStyle(element);

      if (style.position === 'fixed') {
        if (style.bottom !== 'auto' && style.bottom !== '' && style.bottom !== '0px') {
          const rect = element.getBoundingClientRect();
          if (rect.height > 0 && style.display !== 'none') {
            const visible = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            offset += visible;

            if(document.querySelector('#wpadminbar')){
              const adminBarHeight = document.querySelector('#wpadminbar').offsetHeight;
              if(offset == adminBarHeight){
                offset -= adminBarHeight
              }
            }
          }
        }
        return offset;
      }

      Array.from(element.children).forEach(child => {
        offset += addFixedOffsetsRecursively(child);
      });

      return offset;
    }

    const calculateFixedOffset = () => {
      let offset = 0;
      let node = bar.previousElementSibling;

      while (node) {
        offset += addFixedOffsetsRecursively(node);
        node = node.previousElementSibling;
      }

      if(document.querySelector('#wpadminbar')){
        offset += document.querySelector('#wpadminbar').offsetHeight;
      }

      offset = Math.floor(offset);

      bar.style.setProperty('--fixed-offset', offset + 'px');
    }

    const updateBarHeight = () => {
      bar.classList.add('transition-none!', 'resizing');
      height = bar.offsetHeight;
      document.documentElement.style.setProperty('--quick-nav-main-height', height + 'px');
      document.documentElement.style.setProperty('--quick-nav-small-height', (isDesktop() ? 69 : height) + 'px');
      bar.classList.remove('transition-none!', 'resizing');
    }

    const updateScrollStatus = () => {
      const offset = 0;
      const scrollY = window.scrollY;

      if (scrollY > startHeight) {
        if (!bar.classList.contains('scrolling')) {
          bar.classList.add('transition-none');
          setTimeout(() => {
            bar.classList.remove('transition-none');
          }, 250);
        }

        bar.classList.add('scrolling');
        if (scrollY < lastScrollY) {
          if (!scrollingUpActive && (lastScrollY - scrollY) > offset && !bar.classList.contains('scrolling-up')) {
            bar.classList.add('scrolling-up');
            bar.classList.remove('scrolling-down');
            if((isDesktop() && fixedScrollDesktop) || (!isDesktop() && fixedScrollMobile)){
              document.documentElement.style.setProperty('--current-quick-nav-main-height', 'var(--quick-nav-small-height)');
            }else{
              document.documentElement.style.setProperty('--current-quick-nav-main-height', '0px');
            }
            scrollingUpActive = true;
            scrollingDownActive = false;
          }

          if(scrollingUpActive){
            lastScrollY = scrollY;
          }
        } else if (scrollY > lastScrollY) {
          if (!scrollingDownActive && (scrollY - lastScrollY) > offset && !bar.classList.contains('scrolling-down')) {
            bar.classList.add('scrolling-down');
            bar.classList.remove('scrolling-up');
            if((isDesktop() && hideOnScrollDownDesktop) || (!isDesktop() && hideOnScrollDownMobile)){
              document.documentElement.style.setProperty('--current-quick-nav-main-height', '0px');
            }else{
              document.documentElement.style.setProperty('--current-quick-nav-main-height', 'var(--quick-nav-small-height)');
            }
            scrollingDownActive = true;
            scrollingUpActive = false;
          }
          
          if(scrollingDownActive){
            lastScrollY = scrollY;
          }
        }
      } else {
        if (bar.classList.contains('scrolling')) {
          bar.classList.add('transition-none');
          setTimeout(() => {
            bar.classList.remove('transition-none');
          }, 250);
        }

        bar.classList.remove('scrolling');
        bar.classList.remove('scrolling-up');
        bar.classList.remove('scrolling-down');
        scrollingUpActive = false;
        scrollingDownActive = false;
        lastScrollY = scrollY;
        document.documentElement.style.setProperty('--current-quick-nav-main-height', 'var(--quick-nav-main-height)');
      }
    }

    let scrollRAF = null;
    window.addEventListener('scroll', () => {
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(() => {
        updateScrollStatus();
        setTimeout(calculateFixedOffset, 200);
        scrollRAF = null;
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      calculateStartHeight();
      updateBarHeight();
      setTimeout(calculateFixedOffset, 200);

      setTimeout(() => {
        calculateStartHeight();
        updateBarHeight();
        calculateFixedOffset();
      }, 300)
    }, { passive: true });

    document.body.addEventListener('venueChanged', () => {
      calculateStartHeight();
      setTimeout(calculateFixedOffset, 200);

      setTimeout(() => {
        calculateStartHeight();
        calculateFixedOffset();
      }, 300)
    }, { passive: true });

    document.addEventListener('DOMContentLoaded', () => {
      calculateStartHeight();
      updateBarHeight();
      setTimeout(calculateFixedOffset, 200);
    });
  });
})();